export default {
    blacklist: 'Blacklist',
    searchByName: 'Search by Name',
    search: 'Search',
    create: 'Create Blacklist',
    name: 'Name',
    contactNo: 'Contact No.',
    reason: 'Reason',
    createdDate: 'Created Date',
    status: 'Status',
    congratulation: 'Congratulation',
    deleteBlacklist: 'Delete Blacklist',
    wantToDelete: 'Are you sure you want to delete',
    blacklistIsDeleted: 'Blacklist is deleted'
}
